import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
import _ from "lodash";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import ZoningMap from "views/pages/zoning/zoning-map";
import {
  addZone,
  getZoneTypes,
  getZoneAll
} from "actions/zone/actions";

class Zoning extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);

    this.state = this.props.currentZone
      ? this.props.currentZone
      : {
        name: "",
        description: "",
        bonus: 0,
        end: 0,
        latitude: null,
        longitude: null,
        radius: 1000,
        type: this.props.zoneTypes.length
          ? this.props.zoneTypes[0]
          : "",
        template: false
      };

    this.props.getZoneTypes();
    this.props.getZoneAll();

    this.validator = new SimpleReactValidator({
      locale: "en",
      element: message => <div className="text-danger">{message}</div>
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.zoneTypes, this.props.zoneTypes)) {
      this.setState({
        type: nextProps.zoneTypes[0]
      });
    }
  }

  handleChange = (arr) => {
    const state = Object.assign({}, this.state);
    arr.forEach(item => {
      state[item.key] = item.value;
    });

    this.setState(state);
  };

  handleSave = () => {
    if (this.validator.allValid()) {
      const forSave = Object.assign({}, this.state);
      if (forSave.type !== "RED") {
        forSave.bonus = 0;
      }
      this.props.addZone(forSave);
      this.props.onCancel();
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const {
      zoneTypes,
      zoneAll
    } = this.props;
    const places = zoneAll.map(item => ({
      id: item.id,
      title: item.name,
      bonus: item.bonus,
      description: item.description,
      latitude: item.latitude,
      longitude: item.longitude,
      circle: {
        radius: item.radius,
        clickable: false,
        options: {
          fillColor: item.type,
          fillOpacity: 0.2,
          strokeWeight: 0
        }
      }

      // color: {red: 155, green: 235, blue: 190, alpha: 120}
      // end: 0
    }));
    const {
      bonus,
      description,
      end,
      latitude,
      longitude,
      name,
      radius,
      type,
      template
    } = this.state;

    return (
      <div>
        <div className="">
          <div className="row">
            <div className="col-3">
              <div className="form-group">
                <label>Name</label>
                <input
                  className="form-control form-control-sm"
                  type="text"
                  value={name}
                  name="name"
                  onChange={(ev) => {
                    this.handleChange([{
                      key: ev.target.name,
                      value: ev.target.value,
                    }]);
                  }}
                />
                {this.validator.message("name", name, "required")}
              </div>
            </div>
            <div className="col-2">
              <div className="form-group">
                <label>
                  Radius
                </label>
                <input
                  type="number"
                  value={radius}
                  name="radius"
                  className="form-control form-control-sm"
                  min={100}
                  step={100}
                  onChange={(ev) => {
                    this.handleChange([{
                      key: ev.target.name,
                      value: parseInt(ev.target.value, 10),
                    }]);
                  }}
                />
                {this.validator.message("radius", radius, "required")}
              </div>
            </div>
            <div className="col-3">
              <div className="form-group">
                <label>End Date</label>
                <DatePicker
                  className="d-block w-100"
                  style={{
                    minWidth: 10
                  }}
                  format="YYYY-MM-DD HH:mm"
                  disabledDate={(current) => current && current < moment()
                    .startOf("day")}
                  showTime={{
                    format: "HH:mm",
                    defaultValue: moment("00:00:00", "HH:mm"),
                    minuteStep: 5
                  }}
                  value={end ? moment(end) : null}
                  onChange={(date) => {
                    this.handleChange([{
                      key: "end",
                      value: moment(date)
                        .valueOf(),
                    }]);
                  }}
                />
                {this.validator.message("end", end ? moment(end) : null, "required")}
              </div>
            </div>
            <div className="col-2">
              <div className="form-group">
                <label>Zone Type</label>
                <select
                  className="form-control form-control-sm"
                  name="type"
                  value={type}
                  onChange={ev => this.handleChange([{
                    key: ev.target.name,
                    value: ev.target.value,
                  }])}
                >
                  {zoneTypes.map(item => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {this.validator.message("type", type, "required")}
              </div>
            </div>
            {type === "RED" ?
              <div className="col-2">
                <div className="form-group">
                  <label>
                    Bonus
                  </label>
                  <input
                    type="number"
                    value={bonus}
                    name="bonus"
                    className="form-control form-control-sm"
                    min={0}
                    step={1}
                    onChange={(ev) => {
                      this.handleChange([{
                        key: ev.target.name,
                        value: parseInt(ev.target.value, 10),
                      }]);
                    }}
                  />
                  {this.validator.message("bonus", bonus, "required")}
                </div>
              </div>
              : null}
            <div className="col-8">
              <div className="form-group">
                <input
                  className="form-control form-control-sm"
                  type="text"
                  value={description}
                  name="description"
                  onChange={(ev) => {
                    this.handleChange([{
                      key: ev.target.name,
                      value: ev.target.value,
                    }]);
                  }}
                  placeholder="Description"
                />
              </div>
            </div>
            <div className="col-2">
              <div className="d-flex align-items-center form-check">
                <input
                  id="is-template"
                  type="checkbox"
                  className="form-check-input"
                  checked={template}
                  onChange={(ev) => {
                    this.handleChange([{
                      key: "template",
                      value: !template,
                    }]);
                  }}
                />
                <label className="form-check-label" htmlFor="is-template">
                  Save as template
                </label>
              </div>
            </div>
            <div className="col-2">
              <button
                className="btn btn-sm btn-success btn-block"
                onClick={this.handleSave}
              >
                Add
              </button>
            </div>
          </div>
        </div>

        <ZoningMap
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: 600 }}/>}
          containerElement={<div style={{ minHeight: 600 }}/>}
          mapElement={<div style={{ minHeight: 600 }}/>}
          onChange={this.handleChange}
          latitude={latitude}
          longitude={longitude}
          radius={radius}
          color={type}
          places={places}
        />
        {this.validator.message("latitude", latitude, "required")}
        {this.validator.message("longitude", longitude, "required")}
      </div>
    );
  }
}

Zoning.defaultProps = {
  currentZone: false
};

Zoning.propTypes = {
  currentZone: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};

const mapStateToProps = state => ({
  zoneTypes: state.zone.zoneTypes,
  zoneAll: state.zone.zoneAll,
});

const mapStateToDispatch = dispatch => ({
  addZone: bindActionCreators(addZone, dispatch),
  getZoneTypes: bindActionCreators(getZoneTypes, dispatch),
  getZoneAll: bindActionCreators(getZoneAll, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Zoning);



// WEBPACK FOOTER //
// ./src/views/pages/zoning/create-new-zone.js